// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order-details-container {\n    margin-top: 2rem;\n}\n\n.order-details-table th, .order-details-table td {\n    padding-left: 0 !important;\n}\n\n.order-details-table .order-details-table-options {\n    line-height: 1;\n}\n\n.order-details-table .order-details-table-options td {\n    border-top: 0;\n}\n\n.order-details-table .order-details-table-options td:first-child {\n    padding-left: 20px!important;\n}\n", ""]);
// Exports
module.exports = exports;
